export const ADMIN_ROLE = "ROLE_ADMIN";

export function selectLoginMembership(businesses) {
  if (!Array.isArray(businesses) || businesses.length === 0) {
    return null;
  }
  return (
    businesses.find((membership) => membership.role === ADMIN_ROLE) ||
    businesses[0]
  );
}



// WEBPACK FOOTER //
// ./src/utils/loginMembership.js